import { useState } from 'react';
import ReactPhoneNumberInput, {
  formatPhoneNumber,
} from 'react-phone-number-input';

import { useLoadBundleCssOnce } from '#/zustand-stores/loadCssBundleStore';

import { PhoneInputContainer } from './PhoneInput.styled';

//:horizon://import 'react-phone-number-input/style.css';

type Props = {
  qaId?: string;
  name?: string;
  className?: string;
  disabled?: boolean;
  initialValueFormat?: 'national' | undefined;
  placeholder?: string;
  onChange?: (value: string | undefined) => void;
  value?: string;
  id?: string;
};

export function PhoneInput(props: Props) {
  const {
    qaId,
    className,
    name,
    disabled,
    placeholder,
    onChange,
    value,
    initialValueFormat,
    id,
  } = props;

  const [internalValue, setInternalValue] = useState<string | undefined>(value);

  const handleChange = (newValue: string | undefined) => {
    setInternalValue(newValue);
    onChange?.(newValue ?? '');
  };

  useLoadBundleCssOnce('phoneNumberInput');

  return (
    <PhoneInputContainer className={className} data-qa-id={qaId}>
      <ReactPhoneNumberInput
        name={name}
        value={internalValue}
        disabled={disabled}
        placeholder={placeholder ? formatPhoneNumber(placeholder) : undefined}
        onChange={handleChange}
        countrySelectProps={{ unicodeFlags: true }}
        defaultCountry="US"
        initialValueFormat={initialValueFormat}
        id={id}
      />
    </PhoneInputContainer>
  );
}
